module.exports = __webpack_public_path__ + "static/media/YF54_3.c827af12.jpg";